import branchManagementTankersComponent from './tankers.component';
import printTankersModule from './print'

let branchManagementTankersModule = angular.module('branchManagementTankersHistory', [printTankersModule])
  .component('branchManagementTankersHistory', branchManagementTankersComponent)
  .name;

export default branchManagementTankersModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/tankers/index.js